"use client";

import { text } from "@/static/text";
import { Headset } from "lucide-react";
import { Button } from "../ui/button";
import Image from "next/image";
import FAQ from "../FAQ";
import LandingSection from "../LandingSection";
import Whatsapp from "@/public/icon/whatsapp.svg";
import Rubica from "@/public/icon/rubica.png";
import Link from "next/link";

export default function Support() {
const faqs = [
  {
    id: "1",
    question: "نحوه خرید محصولات شما به چه صورت است ؟",
    answer: "<div class=pb-2 >برای خرید محصولات، بسته به نوع فعالیت خود می توانید از روش های زیر اقدام کنید :</div> <ul><li>مشتریان عمده و مغازه داران : جهت ثبت سفارش و اطلاع از شرایط فروش عمده ، لطفا با شماره موجود در سایت ارتباط برقرار کنید.</li><li>اگر مصرف کننده هستید ، برای تجربه یک خرید راحت ، می توانید سفارش خود را از طریق نمایندگی های معتبر ما در سطح کشور ثبت کنید.</li></ul>"
  },
  {
    id: "2",
    question: "اسمارت در کدام شهر های ایران نماینده دارد ؟",
    answer: "<ul><li>مجموعه اسمارت در اکثر شهر های ایران دارای نمایندگی میباشد.</li></ul>"
  },
  {
    id: "3",
    question: "مجموعه اسمارت شامل چه برند هایی است ؟",
    answer: "<ul><li>شرکت اسمارت ، علاوه بر محصولات ارائه شده در قالب برند اسمارت ، نماینده انحصاری برند های اکو و دفنه بانیو می باشد .</li></ul>"
  }
];

  const supportCards = [
    { id: 1, name: "واتساپ", link: "https://wa.me/9809192387002", icon: <Image src={Whatsapp} alt="واتساپ اسمارت" width={28} height={22} /> ,text:"مشاوره رایگان" },
    { id: 2, name: "شماره تماس جهت مشاوره", link: "tel:09192387002", icon: <Headset size={32} /> ,text: "مشاوره رایگان" },
    { id: 3, name: "روبیکا", link: "tel:09192387002", icon: <Image src={Rubica} alt="واتساپ اسمارت" width={36} height={36} /> ,text: "مشاوره رایگان"},
  ];

  return (
    <LandingSection 
      title={text.support.title} 
      desc={text.support.desc}
      containerClassName="container-base md:container-xl"
    >
      <div className="w-full flex-wrap md:flex-nowrap space-y-10 lg:space-y-0 flex gap-5 mb-14">
        {supportCards.map((item) => (
          <div key={item.id} className="w-full lg:w-1/3 text-center space-y-3">
            <div className="flex justify-center">{item.icon}</div>
            <h3>{item.name}</h3>
            {/* <div>{text.support.consultation}</div> */}
         
            <Link target="_blank" href={item.link}><Button size={"lg"} variant="berryText">{item.text}</Button></Link>
          </div>
        ))}
      </div>

      <FAQ faqs={faqs}/>
    </LandingSection>
  );
}
